// Fake WhatsApp numbers for validation
export const FAKE_WHATSAPP_NUMBERS = [
  "9999999999", "8888888888", "7777777777", "6666666666", "5555555555",
  "4444444444", "3333333333", "2222222222", "1111111111", "0000000000",
  "1234567890", "0123456789", "9876543210", "9191919191", "9090909090", "0000000001",
  "1231231234", "3213214321", "9898989898", "1010101010", "1234554321"
];
/**
 * Application-wide constants
 * Single source of truth for configuration values
 */

// API Configuration — must be set via REACT_APP_API_BASE_URL in the env file
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// App download link - the Login / Register buttons send users here
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.astro.astro_shubh_app';

// API Endpoints
export const API_ENDPOINTS = {
  // Orders - Download related
  REMEDY_PDF_STREAM: (orderId) => `/orders/remedy-pdf-stream/${orderId}`,
  REMEDY_PDF_TOKEN: (orderId) => `/orders/remedy-pdf-token/${orderId}`,
  
  // Public endpoints
  PUBLIC_DOWNLOAD: (orderId) => `/public/orders/download/${orderId}`,
};

// Download Configuration
export const DOWNLOAD_CONFIG = {
  TOKEN_EXPIRY_MINUTES: 15,
  TOKEN_EXPIRY_SECONDS: 15 * 60,
};

// Browser Detection
export const IN_APP_BROWSERS = /FBAN|FBAV|Instagram|Line|Twitter|Snapchat|WhatsApp|Messenger|MiuiBrowser/i;

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  DOWNLOAD_CONFIG,
  IN_APP_BROWSERS,
};
